import React, { useState } from 'react';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tooltip,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useWorkspace } from './WorkspaceContext.js';
import { PANEL_WIDTH } from './workspaceConstants.js';

// Floating region title in the top left of the map -- also the place where the
// region can be renamed, which used to live on the old region overview page.
const MapTitleChip = () => {
  const { regionName, renameRegion, activeScenario, openMenu } = useWorkspace();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const openEditor = () => {
    setDraft(regionName);
    setEditing(true);
  };

  const save = () => {
    renameRegion(draft);
    setEditing(false);
  };

  return (
    <>
      <Box sx={{
        position: 'absolute', top: '12px', zIndex: 900,
        // The panel is drawn over the map, so the title steps aside for it --
        // in step with the panel's own slide.
        left: openMenu ? `${PANEL_WIDTH + 12}px` : '12px',
        transition: 'left 260ms cubic-bezier(0.4, 0, 0.2, 1)',
        background: 'rgba(255,255,255,0.92)', border: '1px solid #aaa', borderRadius: '5px',
        px: 1.5, py: 0.75, display: 'flex', alignItems: 'center', gap: 1, maxWidth: 'calc(100% - 24px)',
      }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2, overflowWrap: 'anywhere' }}>
            {regionName}
          </Typography>
          {activeScenario && (
            <Typography variant="caption" color="text.secondary">
              Szenario: {activeScenario.name}
            </Typography>
          )}
        </Box>
        <Tooltip title="Region umbenennen">
          <IconButton size="small" onClick={openEditor} aria-label="Region umbenennen">
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Dialog open={editing} onClose={() => setEditing(false)} fullWidth maxWidth="xs">
        <DialogTitle>Region umbenennen</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Name der Region"
            fullWidth
            margin="dense"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditing(false)}>Abbrechen</Button>
          <Button variant="contained" onClick={save} disabled={!draft}>Speichern</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MapTitleChip;
